import * as yup from "yup";

export const promoCreateSchema = yup.object().shape({
  name: yup
    .string()
    .required("This field is required")
    .matches(/^[a-zA-Z0-9]+$/, "Enter valid name"),
  redeem_by: yup.string().required("This field is required"),
  duration: yup.string().required("This field is required"),
});
